import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const SettingsPage = lazy(() => import('~/features/settings/pages/settings-page'));

export const Route = createFileRoute('/_authenticated/_tenant/settings')({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <SettingsPage />
    </Suspense>
  ),
});
